let isFirstLoad = true;

const { cos, PI } = Math;

const zoomToMeters = (zoom, lat) => (
  156543.03392 * cos((lat * PI) / 180)
) / (2 ** zoom);

const getPanoramaByCoordinate = async (
  streetViewService,
  location,
  zoom,
) => new Promise((resolve) => {
  const { google } = window;

  try {
    streetViewService.getPanorama({
      location,
      radius: zoomToMeters(zoom, location.lat) * 100,
      preference: google.maps.StreetViewPreference.NEAREST,
      source: google.maps.StreetViewSource.OUTDOOR,
    },

    (result = {}, status) => {
      if (status !== 'OK' || !result) {
        // Some times the first load fails
        if (isFirstLoad) {
          isFirstLoad = false;
          setTimeout(() => {
            getPanoramaByCoordinate(
                streetViewService,
                location,
                zoom,
            ).then(resolve);
          }, 10);

          return;
        }

        resolve('');
        return;
      }

      if (!result.location || !result.location.pano) {
        resolve('');
        return;
      }

      resolve(result.location.pano);
    });
  } catch (e) {
    resolve('');
  }
});

export default getPanoramaByCoordinate;
